import { useEffect, useState } from 'react';

import { WhiteboardContentDataService } from './services/whiteboard-content-data-service';

export interface UseContentDataServiceOptions {
	contentCreatorId?: string | null;
}

export const useContentDataService = ({ contentCreatorId }: UseContentDataServiceOptions) => {
	const [contentDataService] = useState(() => new WhiteboardContentDataService());

	useEffect(() => {
		contentDataService.setContentData({
			contentCreatorId,
		});
	}, [contentDataService, contentCreatorId]);

	return contentDataService;
};
